module.exports = __webpack_public_path__ + "static/media/pizzaHawaiiana.5ca2ac77.jpeg";